import React from 'react';
import ReactPaginate from 'react-paginate';
import SVGArrow from '../../svg/Arrow';

// required props
// pageCount={this.state.pageCount}
// onPageChange={this.handlePageClick}
const Pagination = props => {
  return props.pageCount <= 1 ? (
    ''
  ) : (
    <ReactPaginate
      containerClassName={props.containerClassName || 'pagination'}
      pageClassName={'pagination__item'}
      activeClassName={'pagination__item--active'}
      previousLabel={<SVGArrow />}
      previousClassName={'pagination__arrow pagination__arrow--previous'}
      nextLabel={<SVGArrow classNames={['svg--flip']} />}
      nextClassName={'pagination__arrow pagination__arrow--next'}
      breakClassName={'pagination__break'}
      marginPagesDisplayed={1}
      pageRangeDisplayed={3}
      {...props}
    />
  );
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/shared/Pagination.js